//alljournals

import React ,{useState}from "react";
import SearchBar from "../../components/universal/SearchBar";
import { allJournalsHeaders } from "./Constants";
import CustomTable from "../../components/universal/CustomTable";
import { AiOutlinePlus } from "react-icons/ai";
import { Link, useNavigate ,useLocation} from "react-router-dom";
import Navbar from "../../components/universal/Navbar";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "../../components/universal/ConfirmToast";
import { AllJournalsHooks } from "./hooks/JournalsHooks";
import JournalModal from './JournalsModal'
import { useSelector } from "react-redux";
function AllJournals({church,selectedJournals}) {
  const {
    value,
    onChangeSearchBar,
    handleDeleteItem,
    reloadData,
    setReloadData,
    fetchAllJournals,
  } = AllJournalsHooks();

  const navigate = useNavigate();
      const location = useLocation();
      const [isModalOpen, setIsModalOpen] = useState(false);
      const [selectedRow, setSelectedRow] = useState(null);
             const { userInfo } = useSelector((state) => state.user);
        const hideUI = location.pathname.includes("addfield")|| userInfo?.roleCode==='17dwer8'||location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");
    const handleAddPromiseClick = () => {
                if (hideUI) {
          // Only open modal if hideUI is true
          setIsModalOpen(true);
        } else {
          // Otherwise navigate to /twg/add
          navigate("/journals/add");
        }
      };
  return (
    <>

    <div className={`App  ${!hideUI?'min-h-screen bg-[#191919] flex p-4 h-fit':'px-4'} `}>
     { !hideUI&&<Navbar />}
      <div className={`flex-1 ${!hideUI&&'md:pl-32'} md:pt-0 pt-20`}>
        <div className="flex flex-col gap-4 h-full">
         { !hideUI&&<SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />}
          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className={`flex w-full ${!hideUI ?'justify-between':'justify-end'} md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2`}>
             { !hideUI &&<p className=" text-white text-3xl font-medium">Journals</p>}
             {!hideUI&& <div className="flex gap-4">
                {/* <Link to={"/journals/add"}> */}
                  <button className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
                  onClick={handleAddPromiseClick}
                  >
                    <AiOutlinePlus /> Create Journal
                  </button>
                {/* </Link> */}
              </div>
}
            </div>
            <div className={`${hideUI && 'relative'}`}>
                          { hideUI &&
                           <div className={`flex gap-4 absolute ${!hideUI?'right-0':'left-0 top-[-1.5rem]'} mt-2`}>
                           <button className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
                  onClick={handleAddPromiseClick}
                  >
                    <AiOutlinePlus /> Create Journal
                  </button>
              </div>
              }
              {
                !hideUI &&
              <CustomTable
                searchFor={"Journals"}
                heightDesktop={"h-[72vh]"}
                width={"w-24"}
                // giving extra width to 2nd column
                nthChildWidth={
                  "[&>*:nth-child(2)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-32 [&>*:nth-child(3)]:w-32"
                }
                data={[]}
                headers={allJournalsHeaders}
                customDataFetch={true}
                customDataFetchFunction={fetchAllJournals}
                reloadData={reloadData}
                setReloadData={setReloadData}
                reverseTable={true}
                notificationTable={true}
                nthChildStyle={"[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"}
                handleToggleClick={(row, isActive) => {
                                  }}
                handleEyeClick={(row) => {
                  navigate("/journals/add", { state: { _id: row?._id } });
                }}
                handleEditClick={(row) => {
                    if (hideUI) {
                        setSelectedRow(row); // pass row into modal
                        setIsModalOpen(true);

                      } else{
                                    navigate("/journals/add", { state: { _id: row?._id } });}
                }}
                handleDeleteClick={(row) => {
                  const options = {
                    customUI: ({ onClose }) => {
                      return (
                        <ConfirmToast
                          title="Are you sure?"
                          message="You want to delete this journal?"
                          onClose={() => onClose()}
                          onSuccess={() => {
                            handleDeleteItem(row?._id);
                            onClose();
                          }}
                        />
                      );
                    },
                    closeOnEscape: true,
                    closeOnClickOutside: true,
                    keyCodeForClose: [8, 32],
                    overlayClassName: "!bg-gray-500 !bg-opacity-75",
                  };

                  confirmAlert(options);
                }}

              />
}
            </div>
          </div>
        </div>
      </div>
    </div>
    <JournalModal
  isOpen={isModalOpen}
  onClose={() => setIsModalOpen(false)}
  rowData={selectedRow}
  hideUI={hideUI}
  reloadData={reloadData}
  setReloadData={setReloadData}
  church={church}
  selectedJournals={selectedJournals}
/>


    </>
  );
}

export default AllJournals;
